export default __webpack_public_path__ + "static/media/pc_turbo_120Mhz_01.7a396bfb.webp";